import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "ic-granny",
	styleUrls: ["./granny.component.scss"],
	templateUrl: "./granny.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class GrannyComponent {}
